import { useEffect, useState } from "react"
import {
  acquireRecaptcha,
  releaseRecaptcha,
  waitForRecaptchaReady,
} from "./recaptchaSingleton"
import { LogError } from "../../helpers/logger"

export function useRecaptcha(auth) {
  const [verifier, setVerifier] = useState(null)
  const [error, setError] = useState(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (!auth) {
      setVerifier(null)
      setError(null)
      setIsReady(false)
      return
    }

    let acquired = false
    let isDisposed = false

    try {
      const recaptchaGetter = acquireRecaptcha(auth)
      setVerifier(recaptchaGetter)
      setError(null)
      setIsReady(false)
      acquired = !!recaptchaGetter

      if (recaptchaGetter) {
        waitForRecaptchaReady(auth)
          .then(() => {
            if (!isDisposed) {
              setIsReady(true)
            }
          })
          .catch((error) => {
            LogError("Failed waiting for reCAPTCHA readiness:", error)
            if (!isDisposed) {
              setVerifier(null)
              setIsReady(false)
              setError(error)
            }
          })
      }
    } catch (error) {
      LogError("Failed to initialize reCAPTCHA verifier:", error)
      setVerifier(null)
      setIsReady(false)
      setError(error)
    }

    return () => {
      isDisposed = true
      if (acquired) {
        releaseRecaptcha()
      }
    }
  }, [auth])

  return { verifier, error, isReady }
}